"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSkipLinkBehavior = void 0;
var default_behavior_1 = require("./../../../common/models/default-behavior");
var bc_skip_link_constants_1 = require("./bc-skip-link-constants");
var helpers_1 = require("../../../common/helpers");
var BcSkipLinkBehavior = (function (_super) {
    __extends(BcSkipLinkBehavior, _super);
    function BcSkipLinkBehavior() {
        return _super.call(this) || this;
    }
    BcSkipLinkBehavior.setUpAll = function () {
        var skipLinkElements = Array.from(document.querySelectorAll("a[class~='".concat(bc_skip_link_constants_1.SKIP_LINK_CONTENT_CLASS, "']")));
        var elements = [];
        for (var i = 0; i < skipLinkElements.length; i++) {
            var element = skipLinkElements[i];
            var bc = new BcSkipLinkBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcSkipLinkBehavior.prototype.configScrollToElement = function () {
        var _this = this;
        (0, helpers_1.addFocusable)(this.mySelf, { tabindex: '0' }, {
            event: function () {
                var element = _this.mySelf.getAttribute('href');
                document.querySelector(element).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            }
        });
    };
    return BcSkipLinkBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSkipLinkBehavior = BcSkipLinkBehavior;
